import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from '../../icons';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

export const TOAST_CLASS_NAMES = {
  classNames: {
    title: 'text-body-sm-medium text-popover-foreground!',
    description: 'text-caption-regular text-muted-foreground!',
    actionButton: 'bg-primary! text-primary-foreground! text-caption-medium',
    cancelButton: 'bg-muted! text-muted-foreground! text-caption-medium',
  },
};

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  // Toasts render outside the masked sections but can carry discount codes
  // (Generate/swap outcomes), so the container itself is masked for Clarity.
  return (
    <div data-clarity-mask="True" className="contents">
      <Sonner
        theme={theme as ToasterProps['theme']}
        className="toaster group"
        toastOptions={TOAST_CLASS_NAMES}
        icons={{
          success: <CircleCheckIcon className="size-4" />,
          info: <InfoIcon className="size-4" />,
          warning: <TriangleAlertIcon className="size-4" />,
          error: <OctagonXIcon className="size-4" />,
          loading: <Loader2Icon className="size-4 animate-spin" />,
        }}
        style={
          {
            '--normal-bg': 'var(--popover)',
            '--normal-text': 'var(--popover-foreground)',
            '--normal-border': 'var(--border)',
            '--border-radius': 'var(--radius)',
          } as React.CSSProperties
        }
        {...props}
      />
    </div>
  );
};

export { Toaster };
